import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import EpisodeSection from './components/EpisodeSection';
import Categories from './components/Categories';
import StorylineFeature from './components/StorylineFeature';
import SeriesGrid from './components/SeriesGrid';
import FaqSection from './components/FaqSection';
import Testimonials from './components/Testimonials';

const pageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '羞羞动漫网 - 分集剧情解说与每话简介',
  description:
    '羞羞动漫网为动漫爱好者提供分集剧情解说与每话简介，通过剧情梳理与故事线解说帮你快速抓住每部番剧的走向。',
  inLanguage: 'zh-CN',
};

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }} />
      <Navbar />
      <main>
        <Hero />
        <EpisodeSection />
        <Categories />
        <StorylineFeature />
        <SeriesGrid />
        <FaqSection />
        <Testimonials />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}